import { useQuery, useQueryClient } from '@tanstack/react-query';

export type DataUploadModel = {
  id: string;
  displayName: string;
  description: string;
  parserType: string;
  displayOrder: number;
  shortName: string;
};

export default function useDataUploadModels() {
  const queryClient = useQueryClient();

  const { data, isFetching, isError } = useQuery<DataUploadModel[]>({
    queryKey: ['data-upload-models'],
    select: (data: DataUploadModel[]) =>
      data.map((model: DataUploadModel) => ({
        ...model,
        description: model.description?.replace(/\\n/g, '\n'),
      })),
  });

  return {
    files: data ?? [],
    isLoading: isFetching,
    isError,
    refetch: () => queryClient.invalidateQueries({ queryKey: ['data-upload-models'] }),
  };
}
